
;(()=>{
 if(!document.body.classList.contains('pb-colour-comparison')||!document.body.classList.contains('template-collection'))return;

 const allowedSorts=['best-selling','price-ascending','price-descending','created-ascending','created-descending'];
 let lastExplicitSort=null,navigating=false;
 function decideSort(query,server,chosen){
  if(allowedSorts.includes(query))return{value:query,action:'keep'};
  const value=!query&&allowedSorts.includes(chosen)?chosen:'best-selling';
  return{value,action:server===value?'replace-url':'navigate'};
 }
 function normalizeSort(bar){
  if(navigating)return false;
  const url=new URL(window.location.href),query=url.searchParams.get('sort_by');
  const decision=decideSort(query,bar.dataset.pbServerSort,lastExplicitSort);
  if(decision.action==='keep'){lastExplicitSort=decision.value;return true;}
  url.searchParams.set('sort_by',decision.value);
  if(decision.action==='replace-url'){
   window.history.replaceState(window.history.state,'',url.toString());
   const select=bar.querySelector('#SortBy');if(select)select.value=decision.value;lastExplicitSort=decision.value;return true;
  }
  navigating=true;window.location.replace(url.toString());return false;
 }
 document.addEventListener('change',event=>{if(event.target.matches('#SortBy')&&allowedSorts.includes(event.target.value))lastExplicitSort=event.target.value;},true);
 window.addEventListener('popstate',()=>{lastExplicitSort=new URL(window.location.href).searchParams.get('sort_by');scan();});

 const media=window.matchMedia('(max-width:768px)');
 const rankFor=(param,label)=>{
  const key=(param||'').toLowerCase(),name=(label||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  const params=['serienname','kategorie','alter','k_rpergr_e','radgr_e','gr_e'];
  const index=params.findIndex(p=>key==='filter.p.m.custom.'+p);if(index>=0)return index;
  if(/(?:^|[.])(farbe|color|colour)$/.test(key)||['farbe','color','colour','couleur','kleur'].includes(name))return 6;
  if(key==='filter.v.availability'||['verfugbarkeit','availability','disponibilite','beschikbaarheid'].includes(name))return 7;
  const labels=['serienname','kategorie','alter','korpergroße','radgroße','rahmengroße'];const byName=labels.indexOf(name);return byName>=0?byName:100;
 };
 function reorder(){
  for(const form of document.querySelectorAll('[data-pb-mobile-facets]')){
   const groups=Array.from(form.children).filter(n=>n.hasAttribute('data-pb-facet-param'));
   const ordered=groups.map((node,index)=>({node,index,rank:rankFor(node.dataset.pbFacetParam,node.dataset.pbFacetLabel)})).sort((a,b)=>a.rank-b.rank||a.index-b.index).map(x=>x.node);
   if(groups.some((node,i)=>node!==ordered[i]))ordered.forEach(node=>form.appendChild(node));
   for(const group of groups.filter(n=>rankFor(n.dataset.pbFacetParam,n.dataset.pbFacetLabel)===1)){
    for(const list of group.querySelectorAll('ul.tag-list')){
     const items=Array.from(list.children),sorted=items.map((node,index)=>{const value=node.dataset.pbFacetValueLabel||node.querySelector('.tag__text')?.textContent||node.querySelector('label')?.textContent||node.textContent||node.querySelector('input')?.value||'';const match=value.match(/(\d+(?:[.,]\d+)?)\s*(?:"|″|”|Zoll\b|inch(?:es)?\b)/i);return{node,index,number:match?Number(match[1].replace(',','.')):Infinity};}).sort((a,b)=>a.number-b.number||a.index-b.index).map(x=>x.node);
     if(items.some((node,i)=>node!==sorted[i]))sorted.forEach(node=>list.appendChild(node));
    }
   }
  }
 }
 function scan(){reorder();const bar=document.querySelector('.collection-content [data-pb-mobile-filter-bar]');if(bar)normalizeSort(bar);}
 document.addEventListener('shopify:section:load',scan);
 new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});scan();
})();
